import React from "react";
import { AlertTriangle, ExternalLink } from "lucide-react";

const LIVE_ADMIN = "https://stripwisepays.com/admin";

export const isPreviewHost = () => /preview\.emergentagent\.com$|localhost/.test(window.location.hostname);

export const PreviewBanner = () => !isPreviewHost() ? null : (
  <div className="sticky top-0 z-[80] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#b42318] px-4 py-2.5 text-center text-[13.5px] font-semibold text-white" data-testid="preview-admin-banner">
    <AlertTriangle size={16} className="shrink-0" />
    <span>TEST SITE: real customer chats and quotes are NOT here.</span>
    <a href={LIVE_ADMIN} className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-[#b42318] hover:bg-red-50" data-testid="preview-banner-live-link">Open live admin <ExternalLink size={13} /></a>
  </div>
);
